export default {
  methods: {
    async removeItemFrom(dbKey, fieldKey, item) {
      this.showLoader();

      return (await this.firestoreRefs[dbKey]()).update({
        [fieldKey]: this.$firebase.firestore.FieldValue.arrayRemove(item),
      }).then(() => {
        this.hideLoader();

        return true;
      });
    },
  },
};
